import React, { useCallback, useMemo } from 'react'

import styled from 'styled-components'

import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import SearchMenuList from '../SearchMenu/SearchMenuList'
import SearchMenuListCaption from '../SearchMenu/SearchMenuListCaption'
import SearchMenuListItem from '../SearchMenu/SearchMenuListItem'
import { addGTMEvent } from 'api/googleTagManager'
import { searchSelectPopularDestination } from 'analytics/eventDefinitions'
import withGlobalSearchState from 'contexts/GlobalSearch/withGlobalSearchState'

const StyledLoadingIndicator = styled(LoadingIndicator)`
  border-top: 1px solid ${({ theme }) => theme.palette.neutral.five};
`

interface MappedProps {
  destinations: App.SearchItem[]
  isLoading: boolean
}

interface Props {
  recentSearchItems?: App.SearchItem[]
  popularPlaces?: Array<App.SearchItem>;
  onSearchDestinationSelect: (searchDestination: App.SearchItem) => void
}

function PopularDestinations(props: Props & MappedProps) {
  const {
    destinations,
    isLoading,
    recentSearchItems,
    onSearchDestinationSelect,
    popularPlaces,
  } = props

  const places = popularPlaces ?? destinations
  const popularDestinations = useMemo(() => recentSearchItems ?
    places.filter((destination) => !recentSearchItems.some(searchItem => (
      searchItem.searchType === 'destination' && destination.value === searchItem.value
    ))) : places,
  [recentSearchItems, places])

  const handleClick = useCallback((searchItem: App.SearchItem) => {
    addGTMEvent(searchSelectPopularDestination(searchItem))
    onSearchDestinationSelect(searchItem)
  }, [onSearchDestinationSelect])

  if (!isLoading && popularDestinations.length === 0) {
    return null
  }

  return (<SearchMenuList data-testid="search-popular-destinations">
    <SearchMenuListCaption>Popular places</SearchMenuListCaption>
    {isLoading && <StyledLoadingIndicator inline/>}
    {!isLoading && places.map(destination => <SearchMenuListItem
      key={destination.value}
      searchItem={destination}
      onClick={handleClick}
    />)}
  </SearchMenuList>)
}

PopularDestinations.defaultProps = {
  recentSearchItems: [],
}

export default withGlobalSearchState((globalSearchState): MappedProps => ({
  destinations: globalSearchState.popularDestinations,
  isLoading: globalSearchState.isLoadingPopularDestinations,
}))(PopularDestinations)
